import { render } from "./iconDesign.vue?vue&type=template&id=5669df94&scoped=true"
import script from "./iconDesign.vue?vue&type=script&lang=js"
export * from "./iconDesign.vue?vue&type=script&lang=js"

import "./iconDesign.vue?vue&type=style&index=0&id=5669df94&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5669df94"]])

export default __exports__